import { saveDownloadedFile } from "./browserDownload";
import { gboClient } from "./gboApiClient";
import type { SiteConfig } from "./gboModels";

export type PdfDownloadArg = {
  id: string;
  siteConfig: SiteConfig;
};

export async function downloadInvoicePdf({ id, siteConfig }: PdfDownloadArg) {
  const file = await fetchPdfFile(
    `invoices/${encodeURIComponent(id)}/pdf`,
    siteConfig,
    "Invoice.pdf",
  );
  saveDownloadedFile(file);
}

export async function downloadReceiptPdf({ id, siteConfig }: PdfDownloadArg) {
  const file = await fetchPdfFile(
    `payments/${encodeURIComponent(id)}/receipt`,
    siteConfig,
    "Receipt.pdf",
  );
  saveDownloadedFile(file);
}

async function fetchPdfFile(url: string, siteConfig: SiteConfig, fallbackFileName: string) {
  const result = await gboClient.file(url, {
    tenantId: siteConfig.tenantId,
    fallbackFileName,
  });

  if ("error" in result) throw result.error;

  return result.data;
}
